import { World } from '@ecs/World';
import { Health } from '@components/Health';
import { Shield } from '@components/Shield';
import { Selectable } from '@components/Selectable';
import { ShipClass } from '@components/ShipClass';
import { Tag } from '@components/Tag';
import { RosterLink } from '@components/RosterLink';
import { PLAYER_SHIP_INFO, PlayerShipClass } from '@entities/PlayerShips';

export interface FleetShipSummary {
  id: number;
  shipClass: PlayerShipClass;
  name: string;
  color: string;
  health: number;
  maxHealth: number;
  shield: number;
  maxShield: number;
  selected: boolean;
  groups: number[];
}

/** Data for the fleet bar HUD, one entry per living player ship. */
export function buildFleetSummary(world: World, groups: Record<number, number[]>): FleetShipSummary[] {
  return world.getEntitiesWithComponents(ShipClass, Health, Tag)
    .filter(e => e.getComponent(Tag)!.value === 'player' && !world.isPendingRemoval(e))
    .map(ship => {
      const shipClass = ship.getComponent(ShipClass)!.value;
      const health = ship.getComponent(Health)!;
      const shield = ship.getComponent(Shield);
      return {
        id: ship.id,
        shipClass,
        name: ship.getComponent(RosterLink)?.name ?? PLAYER_SHIP_INFO[shipClass].name,
        color: PLAYER_SHIP_INFO[shipClass].color,
        health: health.current,
        maxHealth: health.max,
        shield: shield?.current ?? 0,
        maxShield: shield?.max ?? 0,
        selected: ship.getComponent(Selectable)?.selected ?? false,
        groups: Object.entries(groups)
          .filter(([, ids]) => ids.includes(ship.id))
          .map(([group]) => Number(group)),
      };
    });
}
